import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useDispatch, useSelector } from 'react-redux';
import { selectFullScreen, setFullScreen } from '../../giftSlice';
import { Grid } from '@mui/material';
import GiftPreview from './GiftPreview';
import GiftNavbar from './GiftNavbar';
import { Chat } from '../Candidate/Chat';

const FullScreen = () => {
  const open = useSelector(selectFullScreen);
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(setFullScreen({ value: false }));
  };
  return (
    <Dialog fullScreen open={open} onClose={handleClose}>
      <AppBar sx={{ position: 'relative', background: '#fff' }}>
        <Toolbar>
          <GiftNavbar />
        </Toolbar>
      </AppBar>
      <Grid
        container
        sx={{
          height: '100%',
          p: 1,
        }}
      >
        <Chat lg={6} />
        <GiftPreview lg={6} />
      </Grid>
    </Dialog>
  );
};

export default FullScreen;
